import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b90e020"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mb-2 d-none d-lg-block",
  style: {"width":"960px","height":"176px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Online Waiver", -1))
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-wrap mt-n1 ms-n2"
}
const _hoisted_5 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"15%"}
}
const _hoisted_6 = { class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center" }
const _hoisted_7 = {
  class: "ms-2 my-1 p-2 flex-fill trip-details rounded-2 text-center",
  style: {"min-width":"20%"}
}
const _hoisted_8 = { class: "waiver-box" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "container"
}
const _hoisted_11 = { class: "row border-bottom" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "col pt-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col fw-bold" }, "Passenger Name"),
  /*#__PURE__*/_createElementVNode("div", { class: "col fw-bold" }, "Date")
], -1))
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  key: 1,
  class: "text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_ModalLoading = _resolveComponent("ModalLoading")!
  const _component_ModalErrorMessage = _resolveComponent("ModalErrorMessage")!
  const _component_ModalInfoMessage = _resolveComponent("ModalInfoMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader, {
      "gt-url": '/' + _ctx.$route.params.gtUrl,
      "organization-name": _ctx.waiver?.organizationName
    }, null, 8, ["gt-url", "organization-name"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.waiver)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "rounded-2",
            src: _ctx.waiver.headerImageUrl
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3,
    (_ctx.waiver)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, " Tour #: " + _toDisplayString(_ctx.waiver.tourId), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.waiver.tourName), 1),
          _createElementVNode("div", _hoisted_7, " Tour Dates: " + _toDisplayString(_ctx.tripDates), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", {
        innerHTML: _ctx.waiver?.waiverHtml
      }, null, 8, _hoisted_9),
      (_ctx.waiver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  ref: "sign-name",
                  class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'SignName') }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signature.signName) = $event)),
                  title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'SignName')
                }, null, 10, _hoisted_13), [
                  [
                    _vModelText,
                    _ctx.signature.signName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, _toDisplayString((new Date()).toLocaleDateString('en-US')), 1)
            ]),
            _hoisted_15
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.waiver)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success mt-3",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signWaiver && _ctx.signWaiver(...args)))
            }, " I AGREE TO THE WAIVER TERMS ABOVE "))
          : _createCommentVNode("", true)
      ]),
      (_ctx.waiver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "W-" + _toDisplayString(_ctx.waiver?.waiverType) + " " + _toDisplayString(_ctx.waiver?.versionDate), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ModalLoading, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.errorMessage != null)
      ? (_openBlock(), _createBlock(_component_ModalErrorMessage, {
          key: 2,
          message: _ctx.errorMessage,
          onClose: _cache[2] || (_cache[2] = ($event: any) => {{ _ctx.errorMessage = null; _ctx.$refs['sign-name']?.focus(); }})
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_ctx.submitted)
      ? (_openBlock(), _createBlock(_component_ModalInfoMessage, {
          key: 3,
          message: "Thank you! You have successfully signed your waiver for this tour. A copy of this waiver has been emailed to the address on record.",
          onClose: _ctx.closeSuccess
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}